import * as Sentry from '@sentry/browser';
import initData from 'init-data';
import { customSentryBeforeSend } from './sentry-to-stackdriver';

window.Sentry = Sentry;

const ignoreErrors = [
    'UET is not defined',
    'should_do_lastpass_here',
    'document.getElementsByClassName.ToString is not a function', // Error generated by a bug in SamsungBrowser/7.2
    `ReferenceError: Can't find variable: MoatMAK`
];

const configSentryWithInitData = () => {
    // If is logged in
    if (initData) {
        if (initData.isLoggedIn) {
            Sentry.setUser({
                id: initData.memberId
            });
            Sentry.setExtra('loggedIn', true);
        }
        if (initData.isHybridAppContext) {
            Sentry.setExtra('isHybridAppContext', true);
        }
        if (initData.isNativeAppContext) {
            Sentry.setExtra('isNativeAppContext', true);
        }
    }
};

const setup = () => {
    if (process && process.env && process.env.NODE_ENV === 'production') {
        try {
            // https://docs.sentry.io/error-reporting/configuration/?platform=javascript
            Sentry.init({
                dsn:
                    'https://aded37c82da24c40b403e8790998c27d@sentry.io/143263',
                environment: window.location.host,
                whitelistUrls: [
                    /se1-testnginximg-01\.intranet\.tradera\.com/,
                    /(http|https):\/\/(www\.|beta-a\.|beta-b\.|beta-c\.)tradera\.(com|se)/,
                    /(http|https):\/\/static\.tradera\.net/,
                    /\/\/static\.tradera\.net/,
                    /http?:\/\/se1-testnginximg-01\.intranet\.tradera\.com/
                ],
                blacklistUrls: [
                    /chrome:\/\//i,
                    /extensions\//i,
                    /moz-extension:\/\//i,
                    /graph\.facebook\.com/i,
                    /connect\.facebook\.net\/en_US\/all\.js/i,
                    /pixelsafe\.adsafeprotected.com/,
                    /gstatic/,
                    /gpt/i,
                    /metrics\.itunes\.apple\.com\.edgesuite\.net/i,
                    /cdn\.ampproject\.org/i,
                    /adform\.net/i
                ],
                ignoreErrors: ignoreErrors,
                release: window.releaseVersion,
                sampleRate: 0.2,
                maxBreadcrumbs: 25,
                beforeBreadcrumb(breadcrumb, hint) {
                    if (breadcrumb.category === 'ui.click') {
                        const { target } = hint.event;
                        if (target && target.ariaLabel) {
                            breadcrumb.message = target.ariaLabel;
                        }
                    }
                    return breadcrumb;
                },
                beforeSend: customSentryBeforeSend
            });

            configSentryWithInitData();
        } catch (e) {
            console.error(e); //eslint-disable-line
        }
    }
};

setup();
